var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuetrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.5,
    height: 24,
    viewBox: "0 0 22.5 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trash",
    transform: "translate(-7 -4.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.75,20A1.25,1.25,0,0,0,10,18.75v-7.5a1.25,1.25,0,0,0-2.5,0v7.5A1.25,1.25,0,0,0,8.75,20ZM21.25,5h-5V3.75A3.75,3.75,0,0,0,12.5,0H10A3.75,3.75,0,0,0,6.25,3.75V5h-5a1.25,1.25,0,0,0,0,2.5H2.5V21.25A3.75,3.75,0,0,0,6.25,25h10A3.75,3.75,0,0,0,20,21.25V7.5h1.25a1.25,1.25,0,0,0,0-2.5ZM8.75,3.75A1.25,1.25,0,0,1,10,2.5h2.5a1.25,1.25,0,0,1,1.25,1.25V5h-5Zm8.75,17.5a1.25,1.25,0,0,1-1.25,1.25h-10A1.25,1.25,0,0,1,5,21.25V7.5H17.5ZM13.75,20A1.25,1.25,0,0,0,15,18.75v-7.5a1.25,1.25,0,1,0-2.5,0v7.5A1.25,1.25,0,0,0,13.75,20Z",
    transform: "translate(7 4.667)",
    fill: "#0040A8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuetrash);
export default __webpack_public_path__ + "static/media/buetrash.468c566f42d0125c0011cbdd3359e70b.svg";
export { ForwardRef as ReactComponent };